export default {
  header: 'Alege meniul',
  open_now: 'Deschis acum',
};
